
import { motion } from "framer-motion";
import { Store, QrCode, Phone } from "lucide-react";

const steps = [
  {
    title: "Create Your Queue",
    description: "Set up a digital queue for your business in seconds and manage multiple queues easily.",
    icon: Store,
    image: "https://images.unsplash.com/photo-1486312338219-ce68d2c6f44d",
  },
  {
    title: "Share QR Code",
    description: "Generate a unique QR code for your queue. Display it at your location or share it on your website and social media.",
    icon: QrCode,
    image: "/lovable-uploads/04882c9c-ee93-4f53-bb64-30a9b692fa20.png",
  },
  {
    title: "Customers Join Remotely",
    description: "Customers scan the QR code and join the queue from anywhere, getting real-time updates on their position.",
    icon: Phone,
    image: "/lovable-uploads/5dfd5732-4068-4858-add9-0f87096cabf9.png",
  },
];

export const HowItWorksSection = () => {
  return (
    <section className="py-16 px-4 bg-secondary/30">
      <div className="container mx-auto">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl font-bold mb-4 bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent">
            How It Works
          </h2>
          <p className="text-muted-foreground mb-8">
            Three simple steps to revolutionize your queue management
          </p>
          
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="relative w-full max-w-4xl mx-auto rounded-xl overflow-hidden shadow-xl mb-16"
          >
            <video
              className="w-full"
              autoPlay
              muted
              loop
              playsInline
              poster="/lovable-uploads/04882c9c-ee93-4f53-bb64-30a9b692fa20.png"
            >
              <source 
                src="https://gqrffagxbmccrfomaosq.supabase.co/storage/v1/object/public/video/QNINJA-how-it-works.mp4" 
                type="video/mp4" 
              />
              Your browser does not support the video tag.
            </video>
          </motion.div>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {steps.map((step, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.2 }}
              className="space-y-4"
            >
              <div className="relative h-48 rounded-xl overflow-hidden group">
                <img
                  src={step.image}
                  alt={step.title}
                  className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background/80 to-transparent" />
              </div>
              <h3 className="text-xl font-semibold">{step.title}</h3>
              <p className="text-muted-foreground">{step.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
